// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.countryFlag_main_container{
    background-color: #5CBF14;
    height: 200px;
    position: relative;
}

.countryFlag_container{
    display: flex;
    justify-content: center;
    align-items: center;
    position: absolute;
    top: -0%;
    left: 50%;
    transform: translate(-50%, -50%);
}

.nigflag_container{
    display: flex;
    flex-direction: column;
    align-items: center;
}

.nigflag_containerp{
    font-weight: 400;
    font-size: 16px;
    line-height: 24.46px;
}

.nigflag_container_icon{
    width: 200px;
    height: 200px;
}

.nigflag_container_icon_blur{
    filter: grayscale(100%);
}

.nigflag_container_icon_blur:hover{
    filter: grayscale(0);
}

/* responsiveness starts here */
@media screen and (max-width: 900px){
    .nigflag_containerp{
        font-size: 14px;
    }
    
    .nigflag_container_icon{
        width: 160px;
        height: 170px;
    }
}

@media screen and (max-width: 500px){

    .countryFlag_main_container{
        height: 100px;

    }

    .nigflag_containerp{
        font-size: 12px;
    }
    
    .nigflag_container_icon{
        width: 100px;
        height: 110px;
    }
}


@media screen and (max-width: 380px){
    .nigflag_containerp{
        font-size: 10px;
    }
    
    .nigflag_container_icon{
        width: 85px;
        height: 110px;
    }
}

@media screen and (max-width: 330px){
    
    .nigflag_container_icon{
        width: 75px;
        height: 110px;
    }
}`, "",{"version":3,"sources":["webpack://./src/styles/CountryFlags.css"],"names":[],"mappings":"AAAA;IACI,yBAAyB;IACzB,aAAa;IACb,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,gCAAgC;AACpC;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,oBAAoB;AACxB;;AAEA;IACI,YAAY;IACZ,aAAa;AACjB;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,oBAAoB;AACxB;;AAEA,+BAA+B;AAC/B;IACI;QACI,eAAe;IACnB;;IAEA;QACI,YAAY;QACZ,aAAa;IACjB;AACJ;;AAEA;;IAEI;QACI,aAAa;;IAEjB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,YAAY;QACZ,aAAa;IACjB;AACJ;;;AAGA;IACI;QACI,eAAe;IACnB;;IAEA;QACI,WAAW;QACX,aAAa;IACjB;AACJ;;AAEA;;IAEI;QACI,WAAW;QACX,aAAa;IACjB;AACJ","sourcesContent":[".countryFlag_main_container{\n    background-color: #5CBF14;\n    height: 200px;\n    position: relative;\n}\n\n.countryFlag_container{\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    position: absolute;\n    top: -0%;\n    left: 50%;\n    transform: translate(-50%, -50%);\n}\n\n.nigflag_container{\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n}\n\n.nigflag_containerp{\n    font-weight: 400;\n    font-size: 16px;\n    line-height: 24.46px;\n}\n\n.nigflag_container_icon{\n    width: 200px;\n    height: 200px;\n}\n\n.nigflag_container_icon_blur{\n    filter: grayscale(100%);\n}\n\n.nigflag_container_icon_blur:hover{\n    filter: grayscale(0);\n}\n\n/* responsiveness starts here */\n@media screen and (max-width: 900px){\n    .nigflag_containerp{\n        font-size: 14px;\n    }\n    \n    .nigflag_container_icon{\n        width: 160px;\n        height: 170px;\n    }\n}\n\n@media screen and (max-width: 500px){\n\n    .countryFlag_main_container{\n        height: 100px;\n\n    }\n\n    .nigflag_containerp{\n        font-size: 12px;\n    }\n    \n    .nigflag_container_icon{\n        width: 100px;\n        height: 110px;\n    }\n}\n\n\n@media screen and (max-width: 380px){\n    .nigflag_containerp{\n        font-size: 10px;\n    }\n    \n    .nigflag_container_icon{\n        width: 85px;\n        height: 110px;\n    }\n}\n\n@media screen and (max-width: 330px){\n    \n    .nigflag_container_icon{\n        width: 75px;\n        height: 110px;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
